var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArena7Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 451.2,
    viewBox: "0 0 512 451.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 451.2,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M555.723,250.423c-29.886,0-64.166.751-87.9,4.513-15.823,2.257-23.736,8.272-29.007,24.816-38.678,118.064-75.6,239.136-106.357,357.949-7.034,27.073-10.55,37.6-10.55,44.37,0,9.775,7.031,15.79,22.852,17.3q26.372,2.254,65.927,2.257h8.789c2.118,0,4.233-.015,6.343-.03,2.665.015,5.349.03,8.11.03h8.789c20.218,0,40.436-.754,57.135-2.257,14.063-1.505,19.339-5.264,21.973-18.8,2.639-14.288,6.155-33.839,9.671-49.632h92.3c3.518,15.792,7.031,35.344,9.671,49.632,2.637,13.536,7.91,17.3,21.976,18.8,16.7,1.5,36.917,2.257,57.133,2.257h8.789c2.761,0,5.446-.015,8.11-.03,2.112.015,4.227.03,6.342.03h8.789q39.555,0,65.927-2.257c15.821-1.505,22.852-7.521,22.852-17.3,0-6.769-3.516-17.3-10.547-44.37C792.078,518.888,755.16,397.816,716.485,279.752c-5.273-16.544-13.186-22.559-29.007-24.816-23.733-3.762-58.014-4.513-87.9-4.513ZM549.079,538.44c8.878-42.642,18.812-89.294,28.571-130.938,9.762,41.644,19.7,88.3,28.571,130.938Z",
    transform: "translate(-321.912 -250.423)",
    fill: "#69cba8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.352,253.449c-22.578-2.475-51.142-3.026-76.55-3.026H422.228A1100.044,1100.044,0,0,1,590.751,366.992Q578.578,328.345,566.05,290,544.534,271.141,522.352,253.449Z",
    transform: "translate(-168.136 -250.423)",
    fill: "#80ffd2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.36,251.5A998.066,998.066,0,0,1,652.17,411.917c-.641-2.084-1.289-4.165-1.93-6.246a1026.758,1026.758,0,0,0-241.468-155C402.854,250.876,397.016,251.15,391.36,251.5Z",
    transform: "translate(-215.454 -250.046)",
    fill: "#80ffd2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.208,262.318q186.983,63.62,331.085,199.7-1.755-5.9-3.516-11.8C604.739,362.812,498.361,296.979,378.893,254A25.523,25.523,0,0,0,370.208,262.318Z",
    transform: "translate(-247.878 -244.913)",
    fill: "#80ffd2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.552,270.021q-1.752,5.395-3.493,10.8c141.59,43.276,263.591,119.8,367.091,226.953q-1.839-6.5-3.683-12.993C625.479,389.956,505.761,313.83,367.552,270.021Z",
    transform: "translate(-257.304 -220.277)",
    fill: "#80ffd2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.086,321.9q1.425,6.3,2.847,12.673c88.2,46.845,166.494,110.229,235.595,188.771q-1.812-6.967-3.65-13.94C590.843,431.754,512.786,368.662,425.086,321.9Z",
    transform: "translate(-163.755 -140.481)",
    fill: "#80ffd2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.927,367.354q1.14-5.067,2.28-10.071A789.915,789.915,0,0,0,359.424,295.5q-1.789,5.677-3.566,11.356A792.926,792.926,0,0,1,518.927,367.354Z",
    transform: "translate(-269.876 -181.094)",
    fill: "#80ffd2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.208,393.708c2.318,10.965,4.592,21.821,6.8,32.428H522.866c3.455-16.595,7.072-33.8,10.773-51.071A780.789,780.789,0,0,0,363.3,323.433q-12.466,41.1-24.288,82.25c152.965,17.836,281.805,82.311,390.229,183.588q32.4-.274,55.083-2.208c11.953-1.137,18.883-4.853,21.56-10.815C739.221,500.784,662.251,438.929,573.208,393.708Z",
    transform: "translate(-295.699 -138.119)",
    fill: "#80ffd2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.462,460.673c-7.034,27.073-10.55,37.6-10.55,44.37,0,9.775,7.031,15.79,22.852,17.3q26.372,2.254,65.927,2.257h8.789c2.118,0,4.233-.015,6.345-.03,2.662.015,5.347.03,8.108.03h8.789c20.218,0,40.436-.754,57.135-2.257,14.063-1.505,19.339-5.264,21.973-18.8,2.639-14.288,6.155-33.839,9.671-49.632h92.3c3.518,15.793,7.031,35.344,9.671,49.632,2.637,13.536,7.91,17.3,21.973,18.8,16.7,1.5,36.917,2.257,57.135,2.257h8.789c2.761,0,5.446-.015,8.11-.03,2.112.015,4.227.03,6.342.03h8.789c1.137,0,2.221-.01,3.343-.013-106.945-88.2-235.265-144.162-389.72-159.071Q344.784,413.232,332.462,460.673Z",
    transform: "translate(-321.912 -73.395)",
    fill: "#80ffd2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArena7Icon);
export default __webpack_public_path__ + "static/media/arena7icon.391bfe95e19cd7282c9d7aa69c2b0e9d.svg";
export { ForwardRef as ReactComponent };